import SystemInformationFill from './system-information-fill.component.js'

export * from './system-information-fill.component.js'
export default SystemInformationFill

SystemInformationFill.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-information-fill': SystemInformationFill
  }
}
